export class SorterHelper {
    public static alphaSort = (a: string, b: string) => {
        if (a < b) return -1;
        else if (a > b) return 1;
        else return 0
    }

    public static propertySort = (ascendingBool: boolean, ...orderByKeys: string[]) => (a: any, b: any) =>
        SorterHelper.propertySortInternal(a, b, ascendingBool, ...orderByKeys);

    private static propertySortInternal = (a: any, b: any, ascendingBool: boolean, ...orderByKeys: string[]): number => {
        const orderByString = orderByKeys[0];
        const nextOrderByKeys = orderByKeys.slice(1);

        if (!orderByString) {
            return 0;
        }

        const aHasKey = a!== undefined && a[orderByString] !== undefined;
        const bHasKey = b!== undefined && b[orderByString] !== undefined;

        if (!aHasKey && !bHasKey) {
            return this.propertySortInternal(a, b, ascendingBool, ...nextOrderByKeys);
        }

        if (!aHasKey) {
            return ascendingBool ? -1 : 1;
        }

        if (!bHasKey) {
            return ascendingBool ? 1 : -1;
        }

        if (a[orderByString] < b[orderByString]) {
            return ascendingBool ? -1 : 1;
        }

        if (a[orderByString] > b[orderByString]) {
            return ascendingBool ? 1 : -1;
        }

        return this.propertySortInternal(a, b, ascendingBool, ...nextOrderByKeys);
    }
}